/* Aqana shared design tokens.
   Every key maps to a CSS variable defined in theme.css (light + dark), so any
   inline style reading from C flips with the theme automatically — no re-render.
   This replaces the per-file `const C = {...}` green palettes. */

export const C = {
  // surfaces / structure
  bg:          'var(--c-bg)',
  surface:     'var(--c-surface)',
  white:       'var(--c-white)',
  faint:       'var(--c-faint)',
  border:      'var(--c-border)',
  borderLight: 'var(--c-borderLight)',
  borderHover: 'var(--c-borderHover)',
  line:        'var(--c-line)',

  // text
  text:       'var(--c-text)',
  ink:        'var(--c-ink)',
  textLight:  'var(--c-textLight)',
  slate:      'var(--c-slate)',
  slateLight: 'var(--c-slateLight)',
  muted:      'var(--c-muted)',
  mutedLight: 'var(--c-mutedLight)',

  // brand accent (was green → blue)
  green:       'var(--c-green)',
  greenLight:  'var(--c-greenLight)',
  greenDark:   'var(--c-greenDark)',
  greenBorder: 'var(--c-greenBorder)',

  // danger
  red:       'var(--c-red)',
  redLight:  'var(--c-redLight)',
  redBorder: 'var(--c-redBorder)',
  redText:   'var(--c-redText)',

  // info / category accents
  blue:        'var(--c-blue)',
  blueLight:   'var(--c-blueLight)',
  blueBorder:  'var(--c-blueBorder)',
  amber:       'var(--c-amber)',
  amberLight:  'var(--c-amberLight)',
  amberBorder: 'var(--c-amberBorder)',
  purple:      'var(--c-purple)',
  purpleLight: 'var(--c-purpleLight)',
  teal:        'var(--c-teal)',
  tealLight:   'var(--c-tealLight)',
  pink:        'var(--c-pink)',
  userBubble:  'var(--c-userBubble)',

  // success — green keeps its real job
  success:      'var(--c-success)',
  successLight: 'var(--c-successLight)',

  // chrome
  topbar:            'var(--c-topbar)',
  sidebar:           'var(--c-sidebar)',
  sidebarText:       'var(--c-sidebarText)',
  sidebarActiveBg:   'var(--c-sidebarActiveBg)',
  sidebarActiveText: 'var(--c-sidebarActiveText)',
};

export const FONT = "'Plus Jakarta Sans', sans-serif";

export default C;
